module.exports = __webpack_public_path__ + "media/images/story/typo/greetingsResort-311bbbbdc2620158dc865e7a701cb0f2.svg";